import { Base } from '@studiometa/js-toolkit';
import MenuItem from '../molecules/Menu/MenuItem.js';

/**
 * Homepage class.
 */
export default class Header extends Base {
  /**
   * Class cofnig
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Header',
    components: {
      MenuItem,
    },
    refs: ['burger', 'closeMenu', 'navItem', 'overlay'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.menuIsOpen = false;
    this.body = document.querySelector('body');
    this.alreadyAppend = false;
  }

  /**
   * Close last submenu when clicked on another submenu
   * @returns {void}
   */
  onMenuItemOpen() {
    this.$children.MenuItem.forEach((element) => {
      if (element.$options.depth === 2 && element.open === true) {
        element.closeSubmenu();
      }
    });
  }

  /**
   * Handle closing menu when click out of menu panel
   * @returns {void}
   */
  onOverlayClick() {
    this.closeMenu();
  }

  /**
   * Handle burger click
   * @returns {void}
   */
  onBurgerClick() {
    if (this.menuIsOpen) this.closeMenu();
    else this.openMenu();
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openMenu() {
    this.body.classList.add('overflow-hidden', 'fixed', 'w-full');
    this.body.classList.add('menu--open');
    this.menuIsOpen = true;
  }

  /**
   * Close menu nothin more
   * @returns {void}
   */
  closeMenu() {
    this.body.classList.remove('overflow-hidden', 'fixed', 'w-full');
    this.body.classList.remove('menu--open');
    this.menuIsOpen = false;
    this.$children.MenuItem.filter((child) => child.$isMounted).forEach((child) =>
      child.closeSubmenu(),
    );
  }
}
